import { render, staticRenderFns } from "./form-applications-item.vue?vue&type=template&id=4501b0c4&scoped=true"
import script from "./form-applications-item.vue?vue&type=script&lang=js"
export * from "./form-applications-item.vue?vue&type=script&lang=js"
import style0 from "./form-applications-item.vue?vue&type=style&index=0&id=4501b0c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4501b0c4",
  null
  
)

export default component.exports